$(function () {
  if (!customElements.get('global-toast')) {
    customElements.define(
      'global-toast',
      class GlobalToast extends HTMLElement {
        constructor() {
          super();
          this.container = this.querySelector('div');
          this.template = this.querySelector('.global-toast__template');
          this.toasts = new Map();
          this.counter = 0;

          if (!window.litime) window.litime = {};
          window.litime.showToast = this.showToast.bind(this);
        }

        connectedCallback() {
          this.init();
        }

        init() {}

        showToast(type, message, duration = 2000) {
          const id = `toast-${this.counter++}`;

          // 创建新的toast元素
          const newToast = this.createToast(id, type, message);
          this.container.appendChild(newToast);

          // 存储toast引用
          this.toasts.set(id, {
            element: newToast,
            timer: null,
          });

          // 显示动画
          gsap.fromTo(
            newToast,
            {
              opacity: 0,
              y: -15,
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.25,
              onComplete: () => {
                // 设置自动关闭定时器
                const timer = setTimeout(() => {
                  this.removeToast(id);
                }, duration);

                // 更新计时器引用
                if (this.toasts.has(id)) {
                  this.toasts.get(id).timer = timer;
                }
              },
            }
          );

          return id; // 返回ID，可用于手动关闭
        }

        removeToast(id) {
          const toast = this.toasts.get(id);
          if (!toast) return;

          // 清除定时器
          if (toast.timer) {
            clearTimeout(toast.timer);
          }

          // 隐藏动画
          gsap.to(toast.element, {
            opacity: 0,
            y: -15,
            duration: 0.25,
            onComplete: () => {
              // 移除元素
              if (toast.element.parentNode) {
                toast.element.parentNode.removeChild(toast.element);
              }
              // 从Map中移除
              this.toasts.delete(id);
            },
          });
        }

        createToast(id, type, message) {
          // 克隆模板
          const clone = this.template.content.cloneNode(true).firstElementChild;

          // 设置ID和数据属性
          clone.id = id;
          clone.dataset.type = type;

          // 设置消息内容
          clone.querySelector('.global-toast__message').textContent = message;

          // 设置图标和背景颜色
          const icons = clone.querySelectorAll('.global-toast__icon i');
          icons.forEach((icon) => icon.classList.add('hidden'));

          let backgroundColor;
          switch (type) {
            case 'success':
              icons[0].classList.remove('hidden'); // success图标
              backgroundColor = 'var(--bg-success-color)';
              break;
            case 'warning':
              icons[1].classList.remove('hidden'); // warning图标
              backgroundColor = 'var(--bg-warning-color)';
              break;
            case 'error':
              icons[2].classList.remove('hidden'); // error图标
              backgroundColor = 'var(--bg-error-color)';
              break;
          }

          clone.style.backgroundColor = backgroundColor;

          return clone;
        }
      }
    );
  }
});
